import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initSentry } from "./lib/sentry";
import { setupGlobalErrorHandlers } from "./lib/errorHandlers";

// Validate environment variables on startup
import "./lib/env";

// Initialize error monitoring
initSentry();
setupGlobalErrorHandlers();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
